<template>
  <b-row>
    <b-col lg="12">
      <b-card header="Detalle">
        <b-row>
          <b-col sm="8">
            <h4>GENERAL</h4>
            <br />
            <table class="table table-hover data_rq">
              <tbody>
                <tr>
                  <th>Cliente</th>
                  <td>{{requeriment.service.company.name}}</td>
                </tr>
                <tr>
                  <th>Servicio</th>
                  <td>{{service_type.name}}</td>
                </tr>
                <tr>
                  <th>BL/BOOKING</th>
                  <td>{{requeriment.service.doc_number}}</td>
                </tr>
                <tr>
                  <th>Referencia (para facturación)</th>
                  <td>{{requeriment.service.reference}}</td>
                </tr>
                <tr>
                  <th>Horario de presentación en planta</th>
                  <td>{{requeriment.date | formatDateTime}}</td>
                </tr>
                <tr>
                  <th>Comentarios</th>
                  <td style="white-space: pre-line;">{{requeriment.service.comments}}</td>
                </tr>
              </tbody>
            </table>
            <br />
            <h4>CONTENEDOR</h4>
            <br />
            <table class="table table-hover data_rq">
              <tbody>
                <tr
                  v-if="service_type.code === constants.IMPORTACION && requeriment.charge_type.name !== constants.SUELTA"
                >
                  <th>Línea naviera</th>
                  <td>{{requeriment.service.shipping_line ? requeriment.service.shipping_line.name : '' }}</td>
                </tr>
                <tr v-if="requeriment.charge_type && requeriment.charge_type.name !== constants.SUELTA">
                  <th>Terminal de retiro</th>
                  <td>{{requeriment.deposit_pick ? requeriment.deposit_pick.name : ''}}</td>
                </tr>
                <tr
                  v-if="requeriment.charge_type && requeriment.charge_type.name !== constants.SUELTA && service_type.code === constants.IMPORTACION"
                >
                  <th>Terminal de devolución</th>
                  <td>{{requeriment.deposit ? requeriment.deposit.name : ''}}</td>
                </tr>
                <tr
                  v-if="service_type.code === constants.IMPORTACION && requeriment.charge_type && requeriment.charge_type.name !== constants.SUELTA"
                >
                  <th>Número de contenedor</th>
                  <td>{{requeriment.container_number}}</td>
                </tr>
                <tr v-if="requeriment.charge_type && requeriment.charge_type.name !== constants.SUELTA">
                  <th>Tipo de contenedor</th>
                  <td>{{requeriment.container_size ? requeriment.container_size.name: ''}}</td>
                </tr>
                <tr>
                  <th>Tipo de carga</th>
                  <td>{{requeriment.charge_type ? requeriment.charge_type.name: ''}}</td>
                </tr>
                <tr>
                  <th>Precinto de línea</th>
                  <td>{{requeriment.seal_line}}</td>
                </tr>
                <tr>
                  <th>Precinto de aduana</th>
                  <td>{{requeriment.seal_customs}}</td>
                </tr>
                <tr>
                  <th>Tara</th>
                  <td>{{requeriment.seal_tare}}</td>
                </tr>
                <tr>
                  <th>Hoja de producción</th>
                  <td>{{requeriment.production_sheet}}</td>
                </tr>
                <tr
                  v-if="service_type.code === constants.IMPORTACION && requeriment.charge_type && requeriment.charge_type.name !== constants.SUELTA"
                >
                  <th>Fecha de sobre estadía</th>
                  <td>{{requeriment.container_expiration | formatDate}}</td>
                </tr>
                <tr>
                  <th>Resguardo</th>
                  <td>{{requeriment.guard ? 'SI' : 'NO'}}</td>
                </tr>
                <tr v-if="requeriment.guard">
                  <th>Tipo de custodía</th>
                  <td>{{requeriment.custody ? requeriment.custody.name : 'No indicado' }}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <div v-if="service_type.code !== constants.PORTEO">
          <b-row v-if="hasStow" class="form-group">
            <b-col cols="5">
              <button @click="goRq(stowId)" type="button" class="btn btn-link">Arrumaje asociado</button>
            </b-col>
          </b-row>
          <b-row v-if="originalRqId" class="form-group">
            <b-col cols="5">
              <button
                @click="goRq(originalRqId)"
                type="button"
                class="btn btn-link"
              >Requerimiento asociado</button>
            </b-col>
          </b-row>
        </div>
        <hr />
        <h5>Logs de acciones</h5>
        <table
          v-if="status.code !== constants.PENDIENTE"
          class="table table-bordered table-hover table-striped"
        >
          <thead>
            <tr>
              <th>Responsable</th>
              <th>Acción</th>
              <th>Motivo</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(log,k) in action_logs" :key="k">
              <td>{{log.user ? `${log.user.name} ${log.user.last_name}` : '--' }}</td>
              <td>{{log.comments}}</td>
              <td>{{log.subjects}}</td>
              <td>{{log.created_at | formatDateTime}}</td>
            </tr>
          </tbody>
        </table>
        <hr />
        <h5>Estados del requerimiento</h5>
        <table
          v-if="status.code !== constants.PENDIENTE"
          class="table table-bordered table-hover table-striped"
        >
          <thead>
            <tr>
              <th>Responsable</th>
              <th>Estado inicial</th>
              <th>Estado final</th>
              <th>Fecha</th>
              <th>Tiempo entre estados</th>
              <th>Ubicación</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(log,k) in status_logs" :key="k">
              <td>{{`${log.user.name} ${log.user.last_name}`}}</td>
              <td>{{log.previous && log.previous.status ? log.previous.status.name : '--'}}</td>
              <td>{{log.status ? log.status.name : ''}}</td>
              <td>{{log.created_at | formatDateTime}}</td>
              <td>{{log.diff}}</td>
              <td>
                <button
                  v-if="log.lat && log.lng"
                  @click="openMap(log.lat, log.lng)"
                  type="button"
                  class="btn btn-primary"
                  data-toggle="modal"
                  data-target="#exampleModal"
                >
                  <i class="fa fa-map-marker"></i>
                </button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="6">
                <button
                  v-if="$can('backState', 'Requeriments') && requeriment.status.code !== constants.ANULADO_TRAMARSA"
                  class="btn btn-danger"
                  @click="backState()"
                >Retroceder estado</button>&nbsp;
                <!-- <button
                  v-if="$can('endRequeriment', 'Requeriments') && requeriment.status.code !== constants.FINALIZADO"
                  class="btn btn-danger"
                  @click="endRq()"
                >Finalizar</button>&nbsp; -->
              </td>
            </tr>
          </tfoot>
        </table>
        <ModalMap @close="closeModalMap" :showModalMap="showModalMap" :lat="lat" :lng="lng" />
        <div v-if="showModalMap" class="modal-backdrop fade show"></div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import router from "@/router";
import moment from "moment";
import ModalStow from "./ModalStow";
import ModalMap from "./ModalMap";

export default {
  components: { ModalStow, ModalMap },
  data() {
    return {
      id: this.$route.params.id,
      constants: {},
      requeriment: {
        driver: {},
        truck: {},
        charge_type: {},
        status: {},
        service: {
          company: {},
          deposit: {},
          shipping_line: {}
        }
      },
      endStatus: {},
      next_status: {},
      previous_id: null,
      hasStow: null,
      status_logs: [],
      service_type: {},
      status: {},
      originalRqId: null,
      paymentText: "",
      showModalStow: false,
      showModalMap: false,
      action_logs: [],
      lat: 0,
      lng: 0
    };
  },
  methods: {
    approve() {
      this.updateRq(
        { status_id: this.approvedStatus.id },
        "Requerimiento aprobado"
      );
    },
    cancel() {
      this.updateRq(
        { status_id: this.cancelledStatus.id },
        "Requerimiento anulado"
      );
    },
    updateRq(data, text, reload = true) {
      api.put(`/requeriments/${this.id}`, data).then(response => {
        if (response.success) {
          this.setRq(response);
          this.$toastr.info(text, "", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          if (reload)
            this.$router.push({
              path: `/requeriments/pending`
            });
        }
      });
    },
    goRq(id) {
      this.$router.push({
        path: `/services/detail/${id}`
      });
    },
    createStow() {
      this.showModalStow = true;
    },
    openMap(lat, lng) {
      this.showModalMap = true;
      this.lat = lat;
      this.lng = lng;
    },
    closeModal(data) {
      this.showModalStow = false;
      this.hasStow = data.has_stow;
    },
    closeModalMap() {
      this.showModalMap = false;
    },
    viewFile(folder, filename) {
      const APIURL = process.env.VUE_APP_SOCKET;
      window.open(`${APIURL}${folder}/${filename}`);
    },
    setRq(response) {
      this.requeriment = response.requeriment;
      this.service_type = this.requeriment.service.service_type;
      this.status = this.requeriment.status;
      this.next_status = response.next_status;
      this.previous_id = response.previous_id;
      this.action_logs = this.requeriment.logs;
      this.hasStow = response.has_stow;
      if (this.hasStow) this.stowId = response.stow.id;
    },
    nextStatus(next_status) {
      let data = {
        status_id: next_status.id
      };
      api.put(`requeriments/${this.id}`, data).then(response => {
        let status_log_data = {
          requeriment_id: response.requeriment.id,
          previous_id: this.previous_id,
          status_id: response.requeriment.status_id
        };

        this.setRq(response);

        if (next_status.code === constants.FINALIZADO) {
          api.post("increment_portage", {
            id: response.requeriment.service_id
          });
        }

        api.post("status_logs", status_log_data).then(response => {
          this.previous_id = response.previous_id;
          this.getStatusLogs();
          this.$toastr.success("Estado actualizado", "Requerimiento", {
            positionClass: "toast-top-center",
            closeButton: true
          });
        });
      });
    },
    endRq(){
      const question = `¿Seguro desea finalizar el requerimiento #${this.id}?`

      if(confirm(question)){
        let data = {
          status_id: this.endStatus.id
        }
        api.put(`/requeriments/${this.id}`, data).then(response => {
          
          let last_status = this.status_logs.pop()
          api.post('/status_logs', {
            previous_id: last_status.id,
            status_id: data.status_id,
            requeriment_id: this.id,
          }).then(response => {
            if (this.requeriment.driver_id) {
              let data_push = {
                user_id: this.requeriment.driver_id,
                headings: `Requerimiento actualizado`,
                contents: 'Requerimiento',
                data: {requeriment_id: this.id}
              };
              api.post("/send_push", data_push).then(response => {
                console.log(response);
              });
            }
            alert('Requerimiento actualizado')
            location.reload()
          })
        })
      }
    },
    backState() {
      if (confirm("¿Está seguro desea retroceder un estado?")) {
        api.get(`/back_state/${this.id}`).then(
          response => {
            this.$toastr.success(
              "Se ha retrocedido un estado.",
              "Requerimiento",
              {
                positionClass: "toast-top-center",
                closeButton: true
              }
            );
            this.setRq(response);
            this.status_logs.pop();
          },
          error => {
            this.$toastr.warning(error.message, "Requerimiento", {
              positionClass: "toast-top-center",
              closeButton: true
            });
          }
        );
      }
    },
    getStatusLogs() {
      api.get(`/status_logs/${this.id}`).then(response => {
        this.status_logs = response.status_logs;
        this.status_logs.map(st_log => {
          st_log.diff = "--";
          if (st_log.previous) {
            let ms = moment(st_log.created_at).diff(
              moment(st_log.previous.created_at)
            );
            if (ms > 0) {
              var d = moment.duration(ms);
              var dur = moment.duration(d, "hours");
              var hours = Math.floor(dur.asHours());
              var mins = Math.floor(dur.asMinutes()) - hours * 60;

              st_log.diff =
                (hours > 9 ? hours : "0" + hours) +
                ":" +
                (mins > 9 ? mins : "0" + mins);
            } else {
              st_log.diff = "00:00";
            }
          }
          return st_log;
        });
      });
    }
  },
  mounted() {
    this.constants = constants;
    api.get(`/requeriment/${this.id}`).then(response => {
      if (response.success) this.setRq(response);
    });

    api.get(`/statuses`).then(response => {
      const statuses = response.status;
      this.approvedStatus = statuses.find(x => x.code === constants.APROBADO);
      this.cancelledStatus = statuses.find(
        x => x.code === constants.ANULADO_TRAMARSA
      );
      this.endStatus = statuses.find(x => x.code === constants.FINALIZADO)
    });
    this.getStatusLogs();
  }
};
</script>

<style scoped>
.data_rq th {
  text-transform: uppercase;
  width: 45%;
}
.data_rq td {
  font-weight: 100;
}
</style>

